import { Helmet } from "react-helmet";
import "../../styles/Disclaimer.css";
import { siteUrl } from "../Blogs/data";
const Disclaimer = () => {
  return (
    <>
      <Helmet>
        <title>{"Orion Stars 777 Slots - Disclaimer"}</title>
        <meta
          name="description"
          content={
            "Orion Stars serves as an informational source, providing details about the app and facilitating its download. We do not create or maintain the app."
          }
        />
        <link
          rel="canonical"
          href={`${siteUrl}/disclaimer/orion-stars-777-slots-disclaimer`}
        />
        {/* OG Tags */}
        <meta
          property="og:title"
          content={"Orion Stars 777 Slots - Disclaimer"}
        />
        <meta property="og:site_name" content="Orion star 777 Slots/" />
        <meta
          property="og:url"
          content={`${siteUrl}/disclaimer/orion-stars-777-slots-disclaimer`}
        />
        <meta
          property="og:description"
          content={
            "Orion Stars serves as an informational source, providing details about the app and facilitating its download. We do not create or maintain the app."
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={""} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="disclaimer__container">
        <h1>Orion Stars Disclaimer</h1>
        <h3>We are not the developers of the casino app:</h3>
        <p>
          Orion Stars serves as an informational source, providing details about
          the app and facilitating its download. We do not create or maintain
          the app.
        </p>
        <h3>We do not collect personal information:</h3>
        <p>
          Orion Stars do not gather or store any personal data from visitors to
          our website or users of our services.
        </p>
        <h3>We do not process payments:</h3>
        <p>
          We do not handle any form of payment, whether currency, online
          transactions, or cryptocurrency. Our role is limited to offering
          information and download links for the app.
        </p>
        <h3>Our focus is solely on providing information:</h3>
        <p>
          We aim to inform users about the app's features and offer a convenient
          download link.
        </p>
        <h3>We are not liable for any losses or damages:</h3>
        <p>
          While we make efforts to ensure the accuracy of our information, Orion
          Stars is not responsible for any direct or indirect loss or damage
          resulting from the use of our website or the app.
        </p>
        <h3>
          We do not assume responsibility for risks associated with casino apps:
        </h3>
        <p>
          Using casino apps carries inherent risks. We disclaim any liability
          for any negative consequences or outcomes that may arise from their
          use.
        </p>
      </div>
    </>
  );
};
export default Disclaimer;
